import { useHistory } from 'react-router-dom';

import Parser from 'html-react-parser';

import l from '../../../../lang';

import { Routes } from '../../../../config/routes';

import ButtonLink from '../../../common/button-link';
import CardTitle from '../../../common/card-title';
import Card from '../../../common/card';
import CardDescription from '../../../common/card-description';
import { segmentHomeKycStep2Complete } from '../../../../utils/analytics';

const ReminderStepTwoLimitReached = () => {
  const history = useHistory();

  const onCompanyInformationHandler = () => {
    segmentHomeKycStep2Complete();
    history.push(Routes.COMPANY_INFORMATION);
  }

  return (
    <Card>
      <CardTitle>{l('home.reminder.limit.title')}</CardTitle>
      <CardDescription>
        {Parser(l('home.reminder.limit.desc'))}
        <ButtonLink text={l('home.reminder.limit.link')} onClick={() => history.push(Routes.COMPANY_INFORMATION)} />
        {Parser(l('home.reminder.limit.desc2'))}
      </CardDescription>
    </Card>
  );
};

export default ReminderStepTwoLimitReached;
